export default __webpack_public_path__ + "static/media/csv-export.b740fc5c.svg";